import { HomeMovesCustomerData, ProviderAddress } from '@/src/api/home-moves';

export const getProviderAddressFromCustomerData = (
  customerData: HomeMovesCustomerData,
): ProviderAddress | undefined => {
  if (customerData.automaticAddress) {
    return {
      ...customerData.automaticAddress,
      addressProvider: 'gbgV2' as const,
    };
  }

  if (customerData.manualAddress) {
    return {
      ...customerData.manualAddress,
      addressProvider: 'manual' as const,
    };
  }
};
